let transitions = {};

export default transitions;
